module.exports = __webpack_public_path__ + "media/images/icons/icn_040-0f6e629cd54f04cf777e45be16bf188d.svg";